//TODO: Move to apropriate folder

import { ReactComponent as CourseIcon } from "../assets/icons/course.svg";
import { ReactComponent as SuggestionIcon } from "../assets/icons/suggestions.svg";
import { ReactComponent as ProfileIcon } from "../assets/icons/profile.svg";
import { ReactComponent as InterviewIcon } from "../assets/icons/interview.svg";
import { ReactComponent as ExamIcon } from "../assets/icons/exam.svg";
import { ReactComponent as QuestionIcon } from "../assets/icons/question.svg";
import { ReactComponent as ExitIcon } from "../assets/icons/exit.svg";
import { ReactComponent as VideoIcon } from "../assets/icons/video.svg";
import { ReactComponent as MainIcon } from "../assets/icons/main.svg";
import { ReactComponent as CVIcon } from "../assets/icons/cv.svg";
import { ReactComponent as MicIcon } from "../assets/icons/mic.svg";

export const iconsList = {
  mic: MicIcon,
  main: MainIcon,
  cv: CVIcon,
  video: VideoIcon,
  courses: CourseIcon,
  interviews: InterviewIcon,
  quiz: ExamIcon,
  suggestions: SuggestionIcon,
  table: QuestionIcon,
  profile: ProfileIcon,
  exit: ExitIcon,
};
